import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import { NewPropertiesForm } from 'customer-data-properties/form/NewPropertiesForm';
import { AUTOMATION_PLATFORM_FLOW_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const alwaysUndefined = () => undefined;
export default function CustomPropertiesForm({
  objectId,
  onChange,
  onStatusChange,
  values,
  properties
}) {
  const canEditForm = useHasScope('crm-set-default-properties');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [canEditForm && /*#__PURE__*/_jsx(UILink, {
      "data-test-id": "custom-properties-customize-fields-link",
      external: true,
      href: `/object-manager-settings/${PortalIdParser.get()}/creator-editor/${AUTOMATION_PLATFORM_FLOW_TYPE_ID}`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.CustomPropertiesForm.workflowsFormLink"
      })
    }), /*#__PURE__*/_jsx(NewPropertiesForm, {
      getSavedValue: alwaysUndefined,
      inputMode: objectId !== undefined ? 'edit' : 'create',
      objectTypeId: AUTOMATION_PLATFORM_FLOW_TYPE_ID,
      objectId: objectId,
      onChange: onChange,
      onStatusChange: onStatusChange,
      properties: properties,
      values: values
    })]
  });
}